export default "/Frontend/dist/image-required.55eb2ebdc24463b975af205b3f2ba2b7.svg";